import type { BridgeMessageHandler } from '../message-router.js';

/** Same local cleanup as archive: remove session worktrees. */
export const handleSessionDiscardedMessage: BridgeMessageHandler<'session_discarded'> = (msg, deps) => {
  const sessionId = typeof msg.sessionId === 'string' ? msg.sessionId : '';
  if (!sessionId) return;
  void deps.sessionWorktreeManager.removeSessionWorktrees(sessionId);
};
